<template>
  <v-footer
    class="pos-relative grey800 pa-0"
    clipped inset
    color="transparent"
  >
    <v-container v-if="!winfeedHidden" fluid class="grey700 py-6">
      <v-container>
        <h4 class="text-uppercase text-body-2 font-weight-bold mb-1 text--secondary">
          Live wins
        </h4>

        <WinFeed />
      </v-container>
    </v-container>

    <v-container class="py-12 px-6">
      <v-row>
        <v-col
          cols="12"
          md="12"
          lg="4"
        >
          <h4 class="text-body-1 primary500--text font-weight-bold mb-4" v-text="$t('common.banditcamp')" />
          <p class="text-caption grey300--text lh-1-3" v-text="$t('layout.footer.legal')" />
          <p class="smoller grey300--text mb-6" v-text="$t('layout.footer.owners')" />

          <a
            class="d-inline-flex align-center primary400--text link"
            href="https://www.begambleaware.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <fai class="text-h4 primary500--text mr-3" :icon="['fad', 'ban']" />
            <div class="text-left">
              <div v-t="'layout.footer.18+'" class="lh-1 text-body-2 font-weight-bold" />
              <div v-t="'layout.footer.responsible_gambling'" class="smoller" />
            </div>
          </a>

          <a
            href="https://www.trustpilot.com/review/bandit.camp"
            target="_blank"
            rel="noopener noreferrer"
            class="ml-6 d-inline-flex"
          >
            <v-img class=" link" src="/img/trustpilot.png" width="130" />
          </a>
        </v-col>

        <v-col
          cols="12"
          md="12"
          lg="6" offset-lg="2"
        >
          <div class="d-flex flex-wrap justify-space-between justify-lg-space-around">
            <div>
              <h4
                class="text-body-2 text-uppercase primary500--text font-weight-semibold mb-4"
                v-text="$t('layout.footer.follow_us')"
              />
              <ul class="clean-ul">
                <li v-for="(link, i) in social" :key="i" class="mb-1">
                  <a
                    :href="link.url" target="_blank"
                    class="link text--secondary d-inline-flex align-center" rel="noopener noreferrer"
                  >
                    <fai class="primary600--text text-h6 mr-2" fixed-width :icon="link.icon" />
                    <span v-text="link.title" />
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4
                class="text-body-2 text-uppercase primary500--text font-weight-semibold mb-4"
                v-text="$t('layout.footer.links')"
              />
              <ul class="clean-ul">
                <li>
                  <a
                    v-t="'cta.help_center'"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://banditcamp.tawk.help/"
                    class="link text-body-2 text--secondary d-inline-flex align-center"
                  />
                </li>
                <li>
                  <router-link
                    :to="{name: 'tos'}"
                    class="link text-body-2 text--secondary d-inline-flex align-center"
                    v-text="$t('cta.terms')"
                  />
                </li>
                <li>
                  <router-link
                    :to="{name: 'privacy'}"
                    class="link text-body-2 text--secondary d-inline-flex align-center"
                    v-text="$t('cta.privacy')"
                  />
                </li>
                <li>
                  <router-link
                    :to="{name: 'refund'}"
                    class="link text-body-2 text--secondary d-inline-flex align-center"
                    v-text="$t('cta.refund')"
                  />
                </li>
              </ul>
            </div>

            <div class="d-flex flex-column justify-center">
              <div class="d-flex align-center blue200--text mb-6">
                <fai class="text-h4 blue500--text mr-3" fixed-width :icon="['fad', 'shield-check']" />
                <div class="text-left">
                  <div class="lh-1 text-body-2">
                    SSL 256-bit
                  </div>
                  <div class="smoller">
                    RSA Encryption
                  </div>
                </div>
              </div>

              <router-link
                tag="div"
                :to="{name: 'fairness'}"
                class="d-flex align-center green--text text--lighten-4 mb-6 link"
              >
                <fai class="text-h4 green500--text mr-3" fixed-width :icon="['fad', 'file-contract']" />
                <div class="text-left">
                  <div class="lh-1 text-body-2">
                    Provably Fair
                  </div>
                  <div class="smoller">
                    Blockchain-powered
                  </div>
                </div>
              </router-link>

              <div class="text--secondary text-body-2">
                <h4 class="text-caption font-weight-bold text-uppercase mb-1 grey100--text">
                  Scrap Conversion
                </h4>
                $1.00 = <scrap :amount="100" />
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="12" class="d-md-none">
          <LocaleSwitcher
            :loading="loading.locale"
            @input="onLocaleChange"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import LocaleSwitcher from '@/components/layout/LocaleSwitcher'
import WinFeed from '@/components/layout/WinFeed'

export default {
  components: {
    LocaleSwitcher,
    WinFeed,
  },
  data: () => ({
    loading: {
      locale: false,
    },
    // TODO use conga
    social: [
      { icon: ['fab', 'twitter'], title: 'Twitter', url: 'https://twitter.com/banditcamprust' },
      { icon: ['fab', 'discord'], title: 'Discord', url: 'https://discord.gg/banditcamp' },
      // { icon: ['fab', 'steam'], title: 'Steam Group', url: '#' },
    ],
  }),
  computed: {
    winfeedHidden() {
      return false
    },
  },
  methods: {
    async onLocaleChange(locale) {
      if (this.loading.locale) return
      this.loading.locale = true

      try {
        await this.$i18n.loadAsyncLocale(locale)
        this.$toast.info(this.$t('notice.info.language_switched'))
      } catch (e) {
        this.$toast.error(this.$t('error.unexpected'))
        console.error(e)
      } finally {
        this.loading.locale = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .clean-ul {
    padding: 0;
    list-style: none;
  }

  .smoller {
    font-size: 10px;
  }

  .win-feed ::v-deep .win-feed-item {
    background: grey(400) !important;
  }
</style>
